import axios from '../lib/axios';

export interface AtlasUser {
  email: string;
  displayName?: string;
}

export interface PermissionsResponse {
  isSuperuser: boolean;
  contractCount: number;
  rol: number;
}

export function getImpersonationUserLabel(user: AtlasUser): string {
  const displayName = user.displayName?.trim();
  return displayName && !/^N\/A(?:\s+N\/A)?$/i.test(displayName)
    ? displayName
    : user.email;
}

export async function getImpersonatableUsers(): Promise<AtlasUser[]> {
  const response = await axios.get<AtlasUser[]>('/api/impersonation/users');
  return response.data;
}

export async function getPermissions(): Promise<PermissionsResponse> {
  const response = await axios.get<PermissionsResponse>('/api/permissions');
  return response.data;
}
